import { error } from 'jquery';
import React from 'react'

const baseUrl = process.env.REACT_APP_BASE_URL;

class ProductService {

    

    static products(name, model, brand, size) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size
        }

        return fetch(baseUrl + '/products/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    static productSituation(productId, countryId) {



        const token = localStorage.getItem('token');

        const requestData = {
            "productId": productId,
            "countryId": countryId,

            
        }

        return fetch(baseUrl + '/order/product/situation', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        }).catch(console.log('fetch error'));

    }

    static createProduct(name, model, brand, size, color, cbm, qtyInBox, weight, supplierUniqueId, price, customerPrice) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "color" : color,
            "cbm" : cbm,
            "quantityInBox" : qtyInBox,
            "weight" : weight,
            "supplierUniqueId" : supplierUniqueId,
            "price" : price,
            "customerPrice" : customerPrice,
        }

        return fetch(baseUrl + '/manager/products/create', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    static updateProduct(productId, name, model, brand, size, color, cbm, qtyInBox, weight, supplierUniqueId, price, customerPrice) {



        const token = localStorage.getItem('token');

        const requestData = {

            "productId": productId,
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "color" : color,
            "price" : price,
            "cbm" : cbm,
            "quantityInBox" : qtyInBox,
            "weight" : weight,
            "supplierUniqueId" : supplierUniqueId,
            "customerPrice" : customerPrice,
            
        }

        return fetch(baseUrl + '/manager/products/update', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    static fetchProduct(productId) {



        const token = localStorage.getItem('token');

       

        return fetch(baseUrl + '/manager/products/fetch/'+productId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }


    static productList(name, model, brand, size, color, cpid) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "color" : color,
            "supplierUniqueId" : cpid
        }

        return fetch(baseUrl + '/products/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    static adminProductList(name, model, brand, size, color, cpid) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "color" : color,
            "supplierUniqueId" : cpid
        }

        return fetch(baseUrl + '/admin/product/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }


    static orderProductList(name, model, brand, size, color, countryId) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
            "model": model,
            "brand": brand,
            "size": size,
            "color" : color,
            "countryId" : countryId
        }

        return fetch(baseUrl + '/orders/products/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }


    static setProductBoxQuantity(productId, quantity){

        const token = localStorage.getItem('token');

        const requestData = {

            'productId' : productId,
            'quantity' : quantity
           
            
         }

        return fetch(baseUrl + '/manager/product/set/box/quantity', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }

    static setProductWeight(productId, weight){

        const token = localStorage.getItem('token');

        const requestData = {

            'productId' : productId,
            'weight' : weight
           
            
         }

        return fetch(baseUrl + '/manager/product/set/weight', {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });
    }


   static deleteProduct(productId){

    const token = localStorage.getItem('token');

    return fetch(baseUrl + '/manager/product/delete/'+productId, {
        method: 'DELETE',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });

   }

   static orderedProductList(name, model, brand, size, color, countryId, supplierUniqueId) {



    const token = localStorage.getItem('token');

    const requestData = {
        "name": name,
        "model": model,
        "brand": brand,
        "size": size,
        "color" : color,
        "countryId" : countryId,
        "supplierUniqueId" : supplierUniqueId
    }

    return fetch(baseUrl + '/admin/order/ordered/product/list', {
        method: 'POST',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify(requestData)
    });

}


static pickedProductList(name, model, brand, size, color, cpid, fromDate, toDate, countryId) {



    const token = localStorage.getItem('token');

    const requestData = {
        "name": name,
        "model": model,
        "brand": brand,
        "size": size,
        "color" : color,
        "supplierUniqueId" : cpid,
        "fromDate" : fromDate,
        "toDate" : toDate,
        "countryId" : countryId,
    }

    return fetch(baseUrl + '/admin/order/picked/products', {
        method: 'POST',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify(requestData)
    });

}

static nonShippedProducts(countryId, userId, name, model, brand, size, color, cpid, fromDate, toDate) {



    const token = localStorage.getItem('token');

    const requestData = {
        "name": name,
        "model": model,
        "brand": brand,
        "size": size,
        "color" : color,
        "supplierUniqueId" : cpid,
        "fromDate" : fromDate,
        "toDate" : toDate,
        "countryId" : countryId,
        "userId" : userId,
    }

    return fetch(baseUrl + '/admin/order/non/shipped/products', {
        method: 'POST',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify(requestData)
    });

}

static addProductImage(productId, imageName, imageBase64) {



    const token = localStorage.getItem('token');

    const requestData = {
        "imageName": imageName,
        "imageBase64": imageBase64,
        "productId" : productId,
    }

    return fetch(baseUrl + '/manager/product/image/add', {
        method: 'POST',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify(requestData)
    });

}


static removeProductImage(imageId) {



    const token = localStorage.getItem('token');


    return fetch(baseUrl + '/manager/product/image/remove/'+imageId, {
        method: 'DELETE',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });

}

static setProductImageAsMain(imageId) {



    const token = localStorage.getItem('token');


    return fetch(baseUrl + '/manager/product/set/main/image/'+imageId, {
        method: 'PUT',
        headers: {

            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });

}


static fetchProductImages(productId) {



        const token = localStorage.getItem('token');

       

        return fetch(baseUrl + '/product/image/list/'+productId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }





}

export default ProductService;